<!-- File: IoT-User-Frontend/src/views/Contact.vue -->

<template>
    <div>
        <Breadcrumb mainTitle="Contact" breadContent="Reach out to us for any inquiries or collaborations."
            subTitle="Contact" />

        <!-- Google Map -->
        <div class="contact-page google-map">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.523485490898!2d-84.39628558479646!3d33.77846378068243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f50461664be2d1%3A0x952518115b8c439a!2sWeber%20Space%20Science%20and%20Technology%20Building%2C%20Georgia%20Institute%20of%20Technology%2C%20755%20Ferst%20Dr%2C%20Atlanta%2C%20GA%2030308!5e0!3m2!1sen!2sus!4v1710412345678"
                style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
            </iframe>

        </div>

        <!-- Contact Section -->
        <div class="contact-section section-padding">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="contact-wrap">
                            <div class="contact-inner">
                                <div class="contact-headline">
                                    <h3>Contact Information</h3>
                                </div>
                                <div class="contact-meta-info">
                                    <div class="contact-single-info">
                                        <i class="las la-map-marker-alt"></i>
                                        <h6>Address</h6>
                                        <p>{{ contactInfo.location }}</p>
                                    </div>
                                    <div class="contact-single-info">
                                        <i class="las la-phone"></i>
                                        <h6>Phone</h6>
                                        <p v-if="contactInfo.phone !== 'N/A'">{{ contactInfo.phone }}</p>
                                        <p v-else>Not Available</p>
                                    </div>
                                    <div class="contact-single-info">
                                        <i class="las la-envelope"></i>
                                        <h6>Email</h6>
                                        <p><a :href="'mailto:' + contactInfo.email">{{ contactInfo.email }}</a></p>
                                    </div>
                                    <div class="contact-single-info">
                                        <i class="las la-clock"></i>
                                        <h6>Opening Hours</h6>
                                        <p>{{ contactInfo.opening_hour }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7 offset-lg-1">
                        <div class="section-title">
                            <h6>Let's Get In Touch</h6>
                            <h2>Send Us a Message</h2>
                            <p>Fill out the form below to reach out to us.</p>
                        </div>
                        <div class="contact_form">
                            <form action="#" class="contact-form-validated" novalidate>
                                <div class="row">
                                    <div class="col-xl-6 mb-2">
                                        <input type="text" placeholder="Your Name" name="name" required>
                                    </div>
                                    <div class="col-xl-6 mb-2">
                                        <input type="email" placeholder="Email Address" name="email" required>
                                    </div>
                                    <div class="col-xl-6 mt-1 mb-2">
                                        <input type="text" placeholder="Phone Number" name="phone">
                                    </div>
                                    <div class="col-xl-6 mt-1 mb-2">
                                        <input type="text" placeholder="Subject" name="subject">
                                    </div>
                                    <div class="col-xl-12 mt-1 mb-2">
                                        <textarea name="message" placeholder="Write a Message" required></textarea>
                                        <button type="submit" class="main-btn mt-1">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Breadcrumb from '@/components/Breadcrumb.vue';

export default {
    name: 'Contact',
    components: { Breadcrumb },
    data() {
        return {
            contactInfo: {}
        };
    },
    async mounted() {
        try {
            const response = await axios.get('/assets/data/contact_info.json');
            this.contactInfo = response.data.contact_info;
        } catch (error) {
            console.error('Failed to load contact info:', error);
        }
    }
};
</script>
